import { BaseQueryParams } from "../../../../Components/Core/BasePage/BaseQueryParams";

export class QueryParams extends BaseQueryParams
{
    public type?: string;
    public status?: string;
    public policy?: string;
    public floor?: string;
    public filter?: string;
}